export const getLoaders = (context) => {
  context.commit("updateLoader", {});
};
const LoaderAction = {
  getLoaders
};

export default LoaderAction;
